module.exports = __webpack_public_path__ + "static/img/ai-doctor-workbench.5b6fab8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ai-doctor-workbench.svg
// module id = BIFv
// module chunks = 10